"use client";

import React from "react";
import { Quote } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function TheBlinklabAdvantage() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="263921" id="the-blinklab-advantage" className="bg-background text-foreground overflow-hidden relative ![padding:30px_0px_75px_0px]">
            {}
            <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/10 rounded-lg blur-3xl -z-10 pointer-events-none" />
            
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                    
                    {}
                    <div ref={imageRef} className={`lg:col-span-5 relative transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                        <div className="relative aspect-[4/5] rounded-lg overflow-hidden shadow-2xl shadow-black/80 group border border-white/10 backdrop-blur-md">
                            <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-transparent to-transparent z-10" />
                            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_studio_sumter.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_studio_sumter.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_studio_sumter.png-wvc-sizes" alt="BlinkLab Media Creative Studio in Sumter" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                            {}
                            <div className="absolute top-4 left-4 w-8 h-8 border-t-2 border-l-2 border-primary/60 z-20" />
                            <div className="absolute bottom-4 right-4 w-8 h-8 border-b-2 border-r-2 border-secondary/60 z-20" />
                        </div>
                    </div>

                    {}
                    <div ref={textRef} className={`lg:col-span-7 flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                        <div className="flex items-center gap-4 mb-6">
                            <Separator className="w-12 bg-primary h-[2px]" />
                            <span className="text-primary font-mono text-sm font-bold tracking-widest uppercase">
                                Why BlinkLab
                            </span>
                        </div>

                        <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-8 leading-tight tracking-tighter">
                            The BlinkLab Advantage
                        </h2>

                        <div className="relative mb-10 pl-8 md:pl-12">
                            <Quote className="absolute left-0 top-0 text-secondary/40 size-8 md:size-10 -translate-x-2 -translate-y-2" />
                            <p className="font-default text-2xl md:text-3xl lg:text-4xl text-foreground font-semibold leading-snug">
                                "We build digital experiences that <span className="text-primary">work while you sleep.</span>"
                            </p>
                        </div>

                        <div className="space-y-6 font-default text-muted-foreground text-lg leading-relaxed max-w-2xl">
                            <p>BlinkLab Media combines advanced technology with high-end design to serve small businesses nationwide. Our agency isn't just about aesthetics; it's about engineering high-performance digital tools that drive growth and automate your online presence.</p>
                            <p>
                                From custom web development to strategic social media management, we leverage a premium tech stack to ensure your brand stands out in a crowded marketplace. We treat every project as a partnership, delivering the professional, modern look your business deserves.
                            </p>
                        </div>

                        <div className="mt-12 flex items-center gap-6">
                            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_tech_seal.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_tech_seal.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_tech_seal.png-wvc-sizes" alt="BlinkLab Media Quality Seal" className="h-16 object-contain opacity-90" loading="lazy" />
                            <div className="flex flex-col">
                                
                                
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>;
}